<app-mainscreen>
    <app-simple-page-heading [breadcrumbs]="['Dashboard > MMV Mapping']" title="MMV Mapping"></app-simple-page-heading>
    <div class="row mt-3">
        <div class="col-3">
            <select class="form-select text-grey3 input_" [(ngModel)]="vehicleType" (change)="vehicleTypeChange()">
                <option [text]="item.text" [value]="item.value" *ngFor="let item of productsList"></option>
            </select>
            <label class="label_">Vehicle Segment</label>
        </div>
        <div class="col-3" *ngIf="this.vehicleType == 3">
            <select class="form-select text-grey3 input_" [(ngModel)]="vehicleCategory" (change)="vehicleCategoryChange()">
                <option [text]="item.text" [value]="item.value"  *ngFor="let item of vehicleCategoryList"></option>
            </select>
            <label class="label_">Vehicle Category</label>
        </div>
        <div class="col-3">
            <select class="form-select text-grey3 input_" [(ngModel)]="fuelType" (change)="fuelTypeChange()">
                <option [text]="item.text" [value]="item.value" *ngFor="let item of fuelTypeList"></option>
            </select>
            <label class="label_">Fuel Type</label>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-md-3 position-relative">
            <app-multi-dropdown class="w-100 input_" [items]="makeList" [showSearch]="true" [showAll]="false"
                [showStatus]="false" [showError]="false" placeholder="Make" className="" fontColor="var(--grey3)"
                fontSize="15px" id="Make" [allowSingleCheckOnly]="true" (itemChange)="onMakeSelect($event)">
            </app-multi-dropdown>
            <label class="label_">Make</label>
        </div>
        <div class="col-md-9 position-relative">
            <app-multi-dropdown class="w-100 input_" [items]="modelList" [showSearch]="true" [showAll]="false"
                [showStatus]="false" [showError]="false" placeholder="Model | Variant" className=""
                fontColor="var(--grey3)" fontSize="15px" id="Model_Variant" [allowSingleCheckOnly]="true"
                [supportingText]="true" (itemChange)="onModelSelect($event)">
            </app-multi-dropdown>
            <label class="label_">Model | Variant</label>
        </div>
    </div>

    <div class="collapsible-panel my-2 mb-4" *ngIf="showMappingDetails">
        <div class="panel-header">
            <span class="d-flex align-items-center">Mapping Details</span>
        </div>
        <div class="panel-content collapsed mh-400-scroll border expanded"
            style="padding: 0px 10px !important; height: 100; overflow: visible;">
            <div class="row">
                <div class="col-md-6 border-bottom pt-1" *ngIf="Acko_21">
                    <label class="mb-0">Acko <span *ngIf="(Acko_VehicleCode_21??'') != ''"> ( Code : {{this.Acko_VehicleCode_21}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(21)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Acko_MappedDetails_21">{{ this.Acko_MappedDetails_21 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Aditya_Birla_Health_28">
                    <label class="mb-0">Aditya Birla Health <span *ngIf="(Aditya_Birla_Health_VehicleCode_28??'') != ''"> ( Code : {{this.Aditya_Birla_Health_VehicleCode_28}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(28)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Aditya_Birla_Health_MappedDetails_28">{{
                        this.Aditya_Birla_Health_MappedDetails_28 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="AIC_of_India_29">
                    <label class="mb-0">AIC of India <span *ngIf="(AIC_of_India_VehicleCode_29??'') != ''"> ( Code : {{this.AIC_of_India_VehicleCode_29}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(29)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="AIC_of_India_MappedDetails_29">{{
                        this.AIC_of_India_MappedDetails_29 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Bajaj_Allianz_General_11">
                    <label class="mb-0">Bajaj Allianz General <span *ngIf="(Bajaj_Allianz_General_VehicleCode_11??'') != ''"> ( Code : {{this.Bajaj_Allianz_General_VehicleCode_11}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(11)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Bajaj_Allianz_General_MappedDetails_11">{{
                        this.Bajaj_Allianz_General_MappedDetails_11 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Bharti_AXA_22">
                    <label class="mb-0">Bharti AXA <span *ngIf="(Bharti_AXA_VehicleCode_22??'') != ''"> ( Code : {{this.Bharti_AXA_VehicleCode_22}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(22)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Bharti_AXA_MappedDetails_22">{{
                        this.Bharti_AXA_MappedDetails_22 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Care_Health_30">
                    <label class="mb-0">Care Health <span *ngIf="(Care_Health_VehicleCode_30??'') != ''"> ( Code : {{this.Care_Health_VehicleCode_30}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(30)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Care_Health_MappedDetails_30">{{
                        this.Care_Health_MappedDetails_30 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Chola_MS_23">
                    <label class="mb-0">Chola MS <span *ngIf="(Chola_MS_VehicleCode_23??'') != ''"> ( Code : {{this.Chola_MS_VehicleCode_23}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(23)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Chola_MS_MappedDetails_23">{{ this.Chola_MS_MappedDetails_23
                        }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="DHFL_GI_24">
                    <label class="mb-0">DHFL GI <span *ngIf="(DHFL_GI_VehicleCode_24??'') != ''"> ( Code : {{this.DHFL_GI_VehicleCode_24}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(24)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="DHFL_GI_MappedDetails_24">{{ this.DHFL_GI_MappedDetails_24
                        }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Digit_Insurance_1">
                    <label class="mb-0">Digit Insurance <span *ngIf="(Digit_Insurance_VehicleCode_1??'') != ''"> ( Code : {{this.Digit_Insurance_VehicleCode_1}} )<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(1)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Digit_Insurance_MappedDetails_1">{{
                        this.Digit_Insurance_MappedDetails_1 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Edelweiss_General_15">
                    <label class="mb-0">Edelweiss General <span *ngIf="(Edelweiss_General_VehicleCode_15??'') != ''"> ( Code : {{this.Edelweiss_General_VehicleCode_15}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(15)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Edelweiss_General_MappedDetails_15">{{
                        this.Edelweiss_General_MappedDetails_15 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Future_Generali_14">
                    <label class="mb-0">Future Generali <span *ngIf="(Future_Generali_VehicleCode_14??'') != ''"> ( Code : {{this.Future_Generali_VehicleCode_14}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(14)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Future_Generali_MappedDetails_14">{{
                        this.Future_Generali_MappedDetails_14 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="HDFC_ERGO_3">
                    <label class="mb-0">HDFC ERGO <span *ngIf="(HDFC_ERGO_VehicleCode_3??'') != ''"> ( Code : {{this.HDFC_ERGO_VehicleCode_3}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(3)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="HDFC_ERGO_MappedDetails_3">{{ this.HDFC_ERGO_MappedDetails_3
                        }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="ICICI_Lombard_4">
                    <label class="mb-0">ICICI Lombard <span *ngIf="(ICICI_Lombard_VehicleCode_4??'') != ''"> ( Code : {{this.ICICI_Lombard_VehicleCode_4}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(4)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="ICICI_Lombard_MappedDetails_4">{{
                        this.ICICI_Lombard_MappedDetails_4 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="IFFCO_Tokio_5">
                    <label class="mb-0">IFFCO Tokio <span *ngIf="(IFFCO_Tokio_VehicleCode_5??'') != ''"> ( Code : {{this.IFFCO_Tokio_VehicleCode_5}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(5)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="IFFCO_Tokio_MappedDetails_5">{{
                        this.IFFCO_Tokio_MappedDetails_5 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Kotak_General_16">
                    <label class="mb-0">Kotak General <span *ngIf="(Kotak_General_VehicleCode_16??'') != ''"> ( Code : {{this.Kotak_General_VehicleCode_16}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(16)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Kotak_General_MappedDetails_16">{{
                        this.Kotak_General_MappedDetails_16 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Liberty_General_17">
                    <label class="mb-0">Liberty General <span *ngIf="(Liberty_General_VehicleCode_17??'') != ''"> ( Code : {{this.Liberty_General_VehicleCode_17}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(17)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Liberty_General_MappedDetails_17">{{
                        this.Liberty_General_MappedDetails_17 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Magma_HDI_18">
                    <label class="mb-0">Magma HDI <span *ngIf="(Magma_HDI_VehicleCode_18??'') != ''"> ( Code : {{this.Magma_HDI_VehicleCode_18}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(18)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Magma_HDI_MappedDetails_18">{{ this.Magma_HDI_MappedDetails_18
                        }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="ManipalCigna_31">
                    <label class="mb-0">ManipalCigna <span *ngIf="(ManipalCigna_VehicleCode_31??'') != ''"> ( Code : {{this.ManipalCigna_VehicleCode_31}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(31)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="ManipalCigna_MappedDetails_31">{{
                        this.ManipalCigna_MappedDetails_31 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="National_Insurance_12">
                    <label class="mb-0">National Insurance <span *ngIf="(National_Insurance_VehicleCode_12??'') != ''"> ( Code : {{this.National_Insurance_VehicleCode_12}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(12)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="National_Insurance_MappedDetails_12">{{
                        this.National_Insurance_MappedDetails_12 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Navi_Insurance_10">
                    <label class="mb-0">Navi Insurance <span *ngIf="(Navi_Insurance_VehicleCode_10??'') != ''"> ( Code : {{this.Navi_Insurance_VehicleCode_10}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(10)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Navi_Insurance_MappedDetails_10">{{
                        this.Navi_Insurance_MappedDetails_10 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="New_India_Assurance_25">
                    <label class="mb-0">New India Assurance <span *ngIf="(New_India_Assurance_VehicleCode_25??'') != ''"> ( Code : {{this.New_India_Assurance_VehicleCode_25}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(25)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="New_India_Assurance_MappedDetails_25">{{
                        this.New_India_Assurance_MappedDetails_25 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Niva_Bupa_32">
                    <label class="mb-0">Niva Bupa <span *ngIf="(Niva_Bupa_VehicleCode_32??'') != ''"> ( Code : {{this.Niva_Bupa_VehicleCode_32}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(32)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Niva_Bupa_MappedDetails_32">{{ this.Niva_Bupa_MappedDetails_32
                        }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Oriental_Insurance_13">
                    <label class="mb-0">Oriental Insurance <span *ngIf="(Oriental_Insurance_VehicleCode_13??'') != ''"> ( Code : {{this.Oriental_Insurance_VehicleCode_13}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(13)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Oriental_Insurance_MappedDetails_13">{{
                        this.Oriental_Insurance_MappedDetails_13 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Raheja_QBE_6">
                    <label class="mb-0">Raheja QBE <span *ngIf="(Raheja_QBE_VehicleCode_6??'') != ''"> ( Code : {{this.Raheja_QBE_VehicleCode_6}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(6)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Raheja_QBE_MappedDetails_6">{{ this.Raheja_QBE_MappedDetails_6
                        }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Reliance_General_7">
                    <label class="mb-0">Reliance General <span *ngIf="(Reliance_General_VehicleCode_7??'') != ''"> ( Code : {{this.Reliance_General_VehicleCode_7}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(7)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Reliance_General_MappedDetails_7">{{
                        this.Reliance_General_MappedDetails_7 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Royal_Sundaram_2">
                    <label class="mb-0">Royal Sundaram <span *ngIf="(Royal_Sundaram_VehicleCode_2??'') != ''"> ( Code : {{this.Royal_Sundaram_VehicleCode_2}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(2)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Royal_Sundaram_MappedDetails_2">{{
                        this.Royal_Sundaram_MappedDetails_2 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="SBI_General_19">
                    <label class="mb-0">SBI General <span *ngIf="(SBI_General_VehicleCode_19??'') != ''"> ( Code : {{this.SBI_General_VehicleCode_19}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(19)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="SBI_General_MappedDetails_19">{{
                        this.SBI_General_MappedDetails_19 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Shriram_General_8">
                    <label class="mb-0">Shriram General <span *ngIf="(Shriram_General_VehicleCode_8??'') != ''"> ( Code : {{this.Shriram_General_VehicleCode_8}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(8)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Shriram_General_MappedDetails_8">{{
                        this.Shriram_General_MappedDetails_8 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Star_Health_33">
                    <label class="mb-0">Star Health <span *ngIf="(Star_Health_VehicleCode_33??'') != ''"> ( Code : {{this.Star_Health_VehicleCode_33}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(33)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Star_Health_MappedDetails_33">{{
                        this.Star_Health_MappedDetails_33 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Tata_AIG_20">
                    <label class="mb-0">Tata AIG <span *ngIf="(Tata_AIG_VehicleCode_20??'') != ''"> ( Code : {{this.Tata_AIG_VehicleCode_20}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(20)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Tata_AIG_MappedDetails_20">{{ this.Tata_AIG_MappedDetails_20
                        }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="United_India_Insurance_26">
                    <label class="mb-0">United India Insurance <span *ngIf="(United_India_Insurance_VehicleCode_26??'') != ''"> ( Code : {{this.United_India_Insurance_VehicleCode_26}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(26)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="United_India_Insurance_MappedDetails_26">{{
                        this.United_India_Insurance_MappedDetails_26 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Universal_Sompo_9">
                    <label class="mb-0">Universal Sompo <span *ngIf="(Universal_Sompo_VehicleCode_9??'') != ''"> ( Code : {{this.Universal_Sompo_VehicleCode_9}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(9)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Universal_Sompo_MappedDetails_9">{{
                        this.Universal_Sompo_MappedDetails_9 }}</span>
                </div>
    
                <div class="col-md-6 border-bottom pt-1" *ngIf="Zuno_Insurance_27">
                    <label class="mb-0">Zuno Insurance <span *ngIf="(Zuno_Insurance_VehicleCode_27??'') != ''"> ( Code : {{this.Zuno_Insurance_VehicleCode_27}})<span class="material-symbols-outlined vertical-align-sub text-red font-20 ml-2" (click)="clearCode(27)" title="Clear Mapped Data."> delete </span></span></label>
                    <span class="d-block text-grey3" [title]="Zuno_Insurance_MappedDetails_27">{{
                        this.Zuno_Insurance_MappedDetails_27 }}</span>
                </div>
                <div class="col-md-12 text-end py-2">
                    <app-custom-button text="Update Mapping" [width]="'auto'" [height]="'34px'" leadingIconName=""
                        (click)="UpdateMapping()"></app-custom-button>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <!-- <ng-container *ngFor="let item of activeInsuranceCompanyList">
            <div class="collapsible-panel my-2">
                <div class="panel-header">
                    <span class="d-flex align-items-center">InsuranceName</span>
                </div>
                <div class="panel-content collapsed mh-400-scroll border expanded" style="padding: 0px 10px !important;height: 100;overflow: visible;">
                    <div class="row">
                        <div class="col-12">
                            <div class="row mt-3">    
                                <div class="col-md-3 position-relative">
                                    <app-multi-dropdown  class="w-100 input_"
                                        [items]="makeList" 
                                        [showSearch]="true" 
                                        [showAll]="false" 
                                        [showStatus]="false"
                                        [showError]="false" 
                                        placeholder="Make" 
                                        className=""
                                        fontColor="var(--grey3)"
                                        fontSize="15px"
                                        id="Make_{{item.id}}"
                                        [allowSingleCheckOnly] = "true"
                                        (itemChange)="onMakeSelectIns($event,item.id)">
                                    </app-multi-dropdown>
                                    <label class="label_">Make</label>
                                </div>
                                <div class="col-md-9 position-relative">
                                    <app-multi-dropdown  class="w-100 input_"
                                        [items]="modelList" 
                                        [showSearch]="true" 
                                        [showAll]="false" 
                                        [showStatus]="false"
                                        [showError]="false" 
                                        placeholder="Model | Variant" 
                                        className=""
                                        fontColor="var(--grey3)"
                                        fontSize="15px"
                                        id="Model_Variant_{{item.id}}"
                                        [allowSingleCheckOnly] = "false"
                                        [supportingText]="true"
                                        (itemChange)="onModelSelectIns($event,item.id)">
                                    </app-multi-dropdown>
                                    <label class="label_">Model | Variant</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container> -->

        <!-- Insurance Panels: All 33 Companies -->
        <!-- Acko General Insurance Limited -->
        <div class="collapsible-panel my-2" *ngIf="Acko_21">
            <div class="panel-header">
                <span class="d-flex align-items-center">Acko General Insurance Limited</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Acko_21_MakeList" [showSearch]="true"
                                    [showAll]="false" [showStatus]="false" [showError]="false" placeholder="Make"
                                    fontColor="var(--grey3)" fontSize="15px" id="Make_21" [allowSingleCheckOnly]="true"
                                    (itemChange)="onMakeSelectIns($event,21)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Acko_21_ModelList" [showSearch]="true"
                                    [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_21" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,21)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Aditya Birla Health Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Aditya_Birla_Health_28">
            <div class="panel-header">
                <span class="d-flex align-items-center">Aditya Birla Health Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Aditya_Birla_Health_28_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_28"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,28)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Aditya_Birla_Health_28_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_28" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,28)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Agriculture Insurance Company of India Limited -->
        <div class="collapsible-panel my-2" *ngIf="AIC_of_India_29">
            <div class="panel-header">
                <span class="d-flex align-items-center">Agriculture Insurance Company of India Limited</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="AIC_of_India_29_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_29"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,29)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="AIC_of_India_29_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_29" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,29)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bajaj Allianz General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Bajaj_Allianz_General_11">
            <div class="panel-header">
                <span class="d-flex align-items-center">Bajaj Allianz General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Bajaj_Allianz_General_11_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_11"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,11)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Bajaj_Allianz_General_11_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_11" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,11)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bharti AXA General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Bharti_AXA_22">
            <div class="panel-header">
                <span class="d-flex align-items-center">Bharti AXA General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Bharti_AXA_22_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_22"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,22)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Bharti_AXA_22_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_22" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,22)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Care Health Insurance Ltd (Religare Health Insurance Co. Ltd.) -->
        <div class="collapsible-panel my-2" *ngIf="Care_Health_30">
            <div class="panel-header">
                <span class="d-flex align-items-center">Care Health Insurance Ltd (Religare Health Insurance Co.
                    Ltd.)</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Care_Health_30_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_30"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,30)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Care_Health_30_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_30" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,30)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Chola MS General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Chola_MS_23">
            <div class="panel-header">
                <span class="d-flex align-items-center">Cholamandalam MS General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Chola_MS_23_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_23"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,23)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Chola_MS_23_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_23" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,23)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- DHFL General Insurance Limited -->
        <div class="collapsible-panel my-2" *ngIf="DHFL_GI_24">
            <div class="panel-header">
                <span class="d-flex align-items-center">DHFL General Insurance Limited</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="DHFL_GI_24_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_24"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,24)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="DHFL_GI_24_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_24" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,24)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Edelweiss General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Edelweiss_General_15">
            <div class="panel-header">
                <span class="d-flex align-items-center">Edelweiss General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Edelweiss_General_15_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_15"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,15)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Edelweiss_General_15_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_15" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,15)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Future Generali India Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Future_Generali_14">
            <div class="panel-header">
                <span class="d-flex align-items-center">Future Generali India Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Future_Generali_14_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_14"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,14)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Future_Generali_14_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_14" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,14)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Go Digit General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Digit_Insurance_1">
            <div class="panel-header">
                <span class="d-flex align-items-center">Go Digit General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Digit_Insurance_1_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_1"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,1)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Digit_Insurance_1_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_1" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,1)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- HDFC ERGO General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="HDFC_ERGO_3">
            <div class="panel-header">
                <span class="d-flex align-items-center">HDFC ERGO General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="HDFC_ERGO_3_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_3"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,3)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="HDFC_ERGO_3_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_3" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,3)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ICICI Lombard General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="ICICI_Lombard_4">
            <div class="panel-header">
                <span class="d-flex align-items-center">ICICI Lombard General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="ICICI_Lombard_4_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_4"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,4)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="ICICI_Lombard_4_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_4" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,4)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- IFFCO Tokio General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="IFFCO_Tokio_5">
            <div class="panel-header">
                <span class="d-flex align-items-center">IFFCO Tokio General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="IFFCO_Tokio_5_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_5"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,5)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="IFFCO_Tokio_5_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_5" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,5)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Kotak Mahindra General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Kotak_General_16">
            <div class="panel-header">
                <span class="d-flex align-items-center">Kotak Mahindra General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Kotak_General_16_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_16"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,16)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Kotak_General_16_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_16" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,16)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Liberty Videocon General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Liberty_General_17">
            <div class="panel-header">
                <span class="d-flex align-items-center">Liberty Videocon General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Liberty_General_17_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_17"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,17)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Liberty_General_17_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_17" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,17)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Magma General Insurance Limited -->
        <div class="collapsible-panel my-2" *ngIf="Magma_HDI_18">
            <div class="panel-header">
                <span class="d-flex align-items-center">Magma General Insurance Limited</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Magma_HDI_18_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_18"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,18)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Magma_HDI_18_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_18" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,18)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Manipal Cigna Health Insurance Company Limited -->
        <div class="collapsible-panel my-2" *ngIf="ManipalCigna_31">
            <div class="panel-header">
                <span class="d-flex align-items-center">Manipal Cigna Health Insurance Company Limited</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="ManipalCigna_31_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_31"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,31)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="ManipalCigna_31_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_31" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,31)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Navi General Insurance Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Navi_Insurance_10">
            <div class="panel-header">
                <span class="d-flex align-items-center">Navi General Insurance Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Navi_Insurance_10_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_10"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,10)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Navi_Insurance_10_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_10" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,10)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Niva Bupa Health Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Niva_Bupa_32">
            <div class="panel-header">
                <span class="d-flex align-items-center">Niva Bupa Health Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Niva_Bupa_32_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_32"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,32)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Niva_Bupa_32_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_32" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,32)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Raheja QBE General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Raheja_QBE_6">
            <div class="panel-header">
                <span class="d-flex align-items-center">Raheja QBE General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Raheja_QBE_6_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_6"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,6)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Raheja_QBE_6_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_6" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,6)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Reliance General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Reliance_General_7">
            <div class="panel-header">
                <span class="d-flex align-items-center">Reliance General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Reliance_General_7_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_7"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,7)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Reliance_General_7_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_7" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,7)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Royal Sundaram General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Royal_Sundaram_2">
            <div class="panel-header">
                <span class="d-flex align-items-center">Royal Sundaram General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Royal_Sundaram_2_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_2"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,2)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Royal_Sundaram_2_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_2" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,2)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- SBI General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="SBI_General_19">
            <div class="panel-header">
                <span class="d-flex align-items-center">SBI General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="SBI_General_19_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_19"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,19)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="SBI_General_19_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_19" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,19)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Shriram General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Shriram_General_8">
            <div class="panel-header">
                <span class="d-flex align-items-center">Shriram General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Shriram_General_8_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_8"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,8)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Shriram_General_8_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_8" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,8)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Star Health & Allied Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Star_Health_33">
            <div class="panel-header">
                <span class="d-flex align-items-center">Star Health & Allied Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Star_Health_33_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_33"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,33)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Star_Health_33_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_33" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,33)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tata AIG General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Tata_AIG_20">
            <div class="panel-header">
                <span class="d-flex align-items-center">Tata AIG General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Tata_AIG_20_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_20"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,20)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Tata_AIG_20_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_20" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,20)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- The New India Assurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="New_India_Assurance_25">
            <div class="panel-header">
                <span class="d-flex align-items-center">The New India Assurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="New_India_Assurance_25_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_25"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,25)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="New_India_Assurance_25_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_25" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,25)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- The Oriental Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Oriental_Insurance_13">
            <div class="panel-header">
                <span class="d-flex align-items-center">The Oriental Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Oriental_Insurance_13_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_13"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,13)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Oriental_Insurance_13_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_13" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,13)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- United India Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="United_India_Insurance_26">
            <div class="panel-header">
                <span class="d-flex align-items-center">United India Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="United_India_Insurance_26_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_26"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,26)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="United_India_Insurance_26_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_26" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,26)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Universal Sompo General Insurance Co. Ltd. -->
        <div class="collapsible-panel my-2" *ngIf="Universal_Sompo_9">
            <div class="panel-header">
                <span class="d-flex align-items-center">Universal Sompo General Insurance Co. Ltd.</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Universal_Sompo_9_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_9"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,9)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Universal_Sompo_9_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_9" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,9)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Zuno General Insurance Company Limited (Edelweiss General) -->
        <div class="collapsible-panel my-2" *ngIf="Zuno_Insurance_27">
            <div class="panel-header">
                <span class="d-flex align-items-center">Zuno General Insurance Company Limited (Edelweiss
                    General)</span>
            </div>
            <div class="panel-content collapsed mh-400-scroll border expanded"
                style="padding: 0px 10px !important; height: 100; overflow: visible;">
                <div class="row">
                    <div class="col-12">
                        <div class="row mt-3">
                            <div class="col-md-3 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Zuno_Insurance_27_MakeList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Make" fontColor="var(--grey3)" fontSize="15px" id="Make_27"
                                    [allowSingleCheckOnly]="true" (itemChange)="onMakeSelectIns($event,27)">
                                </app-multi-dropdown>
                                <label class="label_">Make</label>
                            </div>
                            <div class="col-md-9 position-relative">
                                <app-multi-dropdown class="w-100 input_" [items]="Zuno_Insurance_27_ModelList"
                                    [showSearch]="true" [showAll]="false" [showStatus]="false" [showError]="false"
                                    placeholder="Model | Variant" fontColor="var(--grey3)" fontSize="15px"
                                    id="Model_Variant_27" [allowSingleCheckOnly]="true" [supportingText]="true"
                                    (itemChange)="onModelSelectIns($event,27)">
                                </app-multi-dropdown>
                                <label class="label_">Model | Variant</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-mainscreen>